import React from 'react';
import { Image } from 'antd';
import MapView from '../../../components/Map/MapView';
import type { VinInspectionItem } from '../inspectionTypes';
import { getInspectionActiveDamageCount } from '../inspectionUtils';
import { dateFormatter } from '../../../utils';

interface ScanDetailsPanelProps {
  inspection?: VinInspectionItem;
}

const ScanDetailsPanel: React.FC<ScanDetailsPanelProps> = ({ inspection }) => {
  const latitude = inspection?.latitude ? Number(inspection.latitude) : undefined;
  const longitude = inspection?.longitude ? Number(inspection.longitude) : undefined;
  const showValue = (value: string | number | null | undefined) => value ?? 'N/A';
  const formattedDate = inspection?.dateTime ? dateFormatter(inspection.dateTime) : 'N/A';

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div>
        <MapView latitude={latitude} longitude={longitude} />
      </div>

      <div>
        <div className="space-y-2 text-sm text-gray-600">
          <div>
            <span>Date:</span> <span className="text-gray-600 font-semibold">{formattedDate}</span>
          </div>
          <div>
            <span>Terminal:</span> <span className="text-gray-600 font-semibold">{showValue(inspection?.terminal)}</span>
          </div>
          <div>
            <span>Inspector:</span> <span className="text-gray-600 font-semibold">{showValue(inspection?.inspectorName)}</span>
          </div>
          <div>
            <span>Reviewer:</span> <span className="text-gray-600 font-semibold">{showValue(inspection?.reviewerName)}</span>
          </div>
          <div>
            <span>VIN Source:</span> <span className="text-gray-600 font-semibold">{showValue(inspection?.vinSource)}</span>
          </div>
          <div>
            <span>Damage Count:</span>{' '}
            <span className="text-gray-600 font-semibold">{showValue(getInspectionActiveDamageCount(inspection))}</span>
          </div>
          <div>
            <span>App Version:</span> <span className="text-gray-600 font-semibold">{showValue(inspection?.appVersion)}</span>
          </div>
        </div>
      </div>

      <div>
        <div className="space-y-2 text-sm text-gray-600">
          <div>
            <span>Carrier Name:</span> <span className="text-gray-600 font-semibold">{showValue(inspection?.carrierName)}</span>
          </div>

          <div>
            <span>Transport Mode:</span> <span className="text-gray-600 font-semibold">{showValue(inspection?.deliveryMethod)}</span>
          </div>

          <div className="mt-2">
            <div>
              <div className="flex items-center gap-2 mb-3">
                <span className="text-gray-600">Reviewer Signature</span>
              </div>
              {inspection?.reviewerSignature ? (
                <Image
                  src={`${inspection?.reviewerSignature}`}
                  alt="Signature"
                  preview={false}
                  className="max-w-[150px] rounded-md border mr-2"
                />
              ) : (
                <span className="ms-10 text-gray-600 font-semibold">N/A</span>
              )}
            </div>
          </div>

          <div className="mt-2">
            <div>
              <div className="flex items-center gap-2 mb-3">
                <span className="text-gray-600">Inpector Signature</span>
              </div>
              {inspection?.signature ? (
                <Image src={`${inspection?.signature}`} alt="Signature" preview={false} className="max-w-[150px] rounded-md border mr-2" />
              ) : (
                <span className="ms-10 text-gray-600 font-semibold">N/A</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScanDetailsPanel;
